function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dashboard-reference",
  transform: "translate(-2.25 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11710",
  "data-name": "Path 11710",
  d: "M5.286,22.5v3.036h6.961l-10,10L4.4,37.679l10-10v6.961h3.036V22.5Z",
  transform: "translate(0 7.071)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11711",
  "data-name": "Path 11711",
  d: "M27,23.625h3.036v7.589H27Z",
  transform: "translate(8.643 7.464)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11712",
  "data-name": "Path 11712",
  d: "M22.5,18h3.036V33.179H22.5Z",
  transform: "translate(7.071 5.5)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11713",
  "data-name": "Path 11713",
  d: "M18,20.25h3.036V32.393H18Z",
  transform: "translate(5.5 6.286)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11714",
  "data-name": "Path 11714",
  d: "M41.714,2.25H5.286A3.038,3.038,0,0,0,2.25,5.286V23.5H5.286V18.946h36.43V41.714H23.5V44.75H41.714a3.04,3.04,0,0,0,3.036-3.036V5.286A3.038,3.038,0,0,0,41.714,2.25ZM17.429,15.911H5.286V5.286H17.429Zm3.036,0V5.286h21.25V15.911Z",
  fill: "#ac1ede"
}));

var SvgDashboardReference = function SvgDashboardReference(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42.5,
    height: 42.5,
    viewBox: "0 0 42.5 42.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboardReference, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard-reference.3fe31bef.svg";
export { ForwardRef as ReactComponent };